webpackJsonp([40990801466397],{

/***/ 327:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Our market data services (takeover data, articles of association and short selling bans) services are available for purchase through aosphere LLP with whom we have an exclusive global distribution agreement.</p>\n<p>aosphere operates a range of online subscription services including Rulefinder Shareholding Disclosure which analyses the legal requirements for shareholding disclosures in more than 100 jurisdictions.</p>\n<p>Please contact aosphere at <a href=\"https://www.aosphere.com/aos/contact\">www.aosphere.com/aos/contact</a> to obtain subscription information and/or a trial of the takeover data service.</p>","frontmatter":{"path":"/aosphere","title":"Request Trial","columns":1}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---aosphere-d89f8b4d0b6d2ad090a8.js